var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"text-xs-center":"","wrap":""}},[_c('v-flex',{attrs:{"mb-4":""}},[_c('h4',{staticClass:"display-1 font-weight-bold mb-3"},[_vm._v(_vm._s(_vm.$t("redirect_login")))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }